// Imported from the palette module rather than the package root: the root barrel re-exports the
// whole reporting-types domain, and its immutable Records run at module scope, so Rollup cannot
// shake it back out — taking it grew this library's bundle by ~30% to obtain one array of strings.
import { DEFAULT_CHART_COLORS } from '@opengov/reporting-types/src/accountSummary/utils/color';

/**
 * The fallback palette for a chart rendered without an explicit `colors` array.
 *
 * This is the shared chart palette, not a copy of it. Forking it here is what let one report render
 * in two different sets of colors depending on which side picked them. Kept under its own name
 * because every consumer imports it by that name.
 */
export const defaultChartColors: string[] = DEFAULT_CHART_COLORS;
